/**
 * DPos
 * API for DPos
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface StaffMealSearchResult { 
    allowed?: boolean;
    balance?: number;
    fromBranch?: boolean;
    hqId?: number;
    merchantDisplayName?: string;
    merchantId?: number;
    merchantName?: string;
    staffId?: number;
    staffMealId?: number;
    staffName?: string;
    staffNo?: string;
    totalAmount?: number;
    username?: string;
}

